/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import { getAuthToken } from '../../utils/auth';
import { Event } from './analytics.models';

const headers = {
  'Content-Type': 'application/json',
  'X-Analytic-Origin': 'player-stats',
};

const getAuthHeader = () => {
  const authToken = getAuthToken();
  if (authToken) {
    return { Authorization: `Bearer ${authToken.token}` };
  }
};

export const postEventRequest = async (event: Event): Promise<Response> => {
  const url = `${process.env.NEXT_PUBLIC_BA_URL}/analytics`;
  try {
    const response = await fetch(url, {
      keepalive: true,
      method: 'POST',
      headers: {
        ...headers,
        ...getAuthHeader(),
      },
      body: JSON.stringify(event),
    });
    return response;
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error('Error occurred while posting event:', error.message);
    } else {
      console.error('Unexpected error:', error);
    }
    throw error;
  }
};
